import React from 'react';
import { useNavigate } from 'react-router-dom';

function RenewalReview() {
  const navigate = useNavigate();

  // TODO: Replace with actual data from context
  const renewalDetails = {
    membership: {
      type: 'Full Membership',
      price: '£50.00',
      validFrom: '01 January 2024',
      validUntil: '31 December 2024',
    },
    member: {
      name: 'John Smith',
      email: 'john.smith@example.com',
      membershipNumber: 'HDL001',
    },
    payment: {
      method: 'Credit Card',
      last4: '4242',
      total: '£50.00',
    },
  };

  const handleConfirm = () => {
    // TODO: Implement actual confirmation logic
    navigate('/renewal/thank-you');
  };

  return (
    <div className="max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold text-white mb-6">Review Your Renewal</h1>

      <div className="space-y-6">
        <div className="bg-white/5 rounded-lg p-6">
          <h2 className="text-lg font-semibold text-white mb-4">Membership Details</h2>
          <div className="grid grid-cols-2 gap-4 text-gray-300">
            <div>
              <p className="text-gray-400">Type</p>
              <p>{renewalDetails.membership.type}</p>
            </div>
            <div>
              <p className="text-gray-400">Price</p>
              <p>{renewalDetails.membership.price}</p>
            </div>
            <div>
              <p className="text-gray-400">Valid From</p>
              <p>{renewalDetails.membership.validFrom}</p>
            </div>
            <div>
              <p className="text-gray-400">Valid Until</p>
              <p>{renewalDetails.membership.validUntil}</p>
            </div>
          </div>
        </div>

        <div className="bg-white/5 rounded-lg p-6">
          <h2 className="text-lg font-semibold text-white mb-4">Member Information</h2>
          <div className="grid grid-cols-2 gap-4 text-gray-300">
            <div>
              <p className="text-gray-400">Name</p>
              <p>{renewalDetails.member.name}</p>
            </div>
            <div>
              <p className="text-gray-400">Membership Number</p>
              <p>{renewalDetails.member.membershipNumber}</p>
            </div>
            <div className="col-span-2">
              <p className="text-gray-400">Email</p>
              <p>{renewalDetails.member.email}</p>
            </div>
          </div>
        </div>

        <div className="bg-white/5 rounded-lg p-6">
          <h2 className="text-lg font-semibold text-white mb-4">Payment Summary</h2>
          <div className="grid grid-cols-2 gap-4 text-gray-300">
            <div>
              <p className="text-gray-400">Method</p>
              <p>{renewalDetails.payment.method}</p>
            </div>
            <div>
              <p className="text-gray-400">Card Number</p>
              <p>**** **** **** {renewalDetails.payment.last4}</p>
            </div>
            <div className="col-span-2">
              <div className="flex justify-between text-lg font-semibold text-white mt-4">
                <span>Total</span>
                <span>{renewalDetails.payment.total}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-between mt-8">
          <button
            type="button"
            onClick={() => navigate('/renewal/payment')}
            className="text-hdlcc-lightBlue hover:text-hdlcc-blue"
          >
            ← Back
          </button>
          <button
            onClick={handleConfirm}
            className="bg-hdlcc-lightBlue text-white px-8 py-3 rounded-lg hover:bg-hdlcc-blue transition-colors"
          >
            Confirm Renewal
          </button>
        </div>
      </div>
    </div>
  );
}

export default RenewalReview;
